import { Box, Container, Flex } from 'theme-ui';
import { useSettings } from '@backpackjs/storefront';

import { Ctas, CtaMenu } from './Ctas';
import { Logo } from './Logo';
import { Nav } from './Nav';
import { themed } from './Menu.theme';

export const Menu = themed(({ theme, ...props }) => {
  const settings = useSettings();
  const { header } = { ...settings };
  const { logo } = { ...header };

  const backgroundColor = logo?.backgroundColor || '#FFFFFF';
  const adminLinksColor = logo?.adminLinksColor || '#000000';

  return (
    <Container data-comp={Menu.displayName} sx={{ ...theme.wrapper, bg: backgroundColor }}>
      {/* 🍔 🔍  — mobile only */}
      <Box sx={theme.toggle}>
        <CtaMenu adminLinksColor={adminLinksColor} />
      </Box>

      <Flex variant="flex.row.center">
        <Logo />
      </Flex>

      {/* Top level nav */}
      <Nav />

      {/* 🔍 👩‍💻  🛒 */}
      <Ctas adminLinksColor={adminLinksColor} />
    </Container>
  );
});

Menu.displayName = 'Menu';